import CallIcon from '@mui/icons-material/Call';
import {Fab} from '@mui/material';
import {ConferenceStatus} from '@quobis/sippojs';
import {useContext} from 'react';

import {QuobisServiceContext, RouterContext} from '../providers/Context.providers';

import styles from './Dialpad.module.scss';
import {RouteNames} from './RouterContainer';

export default function Dialpad(): JSX.Element {
	const router = useContext(RouterContext);
	const quobisService = useContext(QuobisServiceContext);

	const call = async (): Promise<void> => {
		quobisService?.callService.conferenceStatus$?.subscribe(
			(status) => {
				if (status === ConferenceStatus.DESTROYED) {
					router?.setRoute(RouteNames.DIALPAD);
				}
			},
		);
		router?.setRoute(RouteNames.CALLING);
	};

	return (
		<div className={styles.dialpad}>
			<Fab color="primary" aria-label="call" onClick={call}>
				<CallIcon />
			</Fab>
		</div>
	);
}
